import React from 'react';
import PropTypes from 'prop-types';

import Env from '../../../../util/env';
import {serviceURL} from '../../../../util/uiconstants';

import ProjectList from '../../../Common/ProjectList';

const CompletedProjects = ({...rest}) => {
	const url = `${Env.getBaseURL(serviceURL)}projects?expand=clients,users&filter=completed`;

	const props = {...rest, url};

	return <ProjectList {...props} />;
};

CompletedProjects.propTypes = {};

CompletedProjects.defaultProps = {};

export default CompletedProjects;
